import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';

/**
 * Reusable right-side slide-in panel.
 *
 * Props:
 *   isOpen   {boolean}  - whether the panel is visible
 *   onClose  {function} - called when the overlay or close button is clicked
 *   title    {string}   - panel header title
 *   width    {string}   - desktop width (e.g. '320px'). Defaults to '360px'.
 *                         On mobile (≤768px) the panel always uses 90vw.
 *   children {node}     - panel body content
 *   footer   {node}     - optional floating footer content (e.g. action buttons)
 */
const SlidePanel = ({ isOpen, onClose, title, width = '360px', children, footer }) => {
    return (
        <>
            {isOpen && (
                <div className="slide-panel-overlay" onClick={onClose} />
            )}
            <div
                className={`slide-panel ${isOpen ? 'open' : ''}`}
                style={{ '--slide-panel-width': width }}
            >
                <div className="slide-panel-header">
                    <h2 className="slide-panel-title">{title}</h2>
                    <button
                        className="icon-button"
                        onClick={onClose}
                        title="Close"
                    >
                        <AiOutlineClose />
                    </button>
                </div>
                <div className="slide-panel-content">
                    {children}
                </div>
                {footer && (
                    <div className="slide-panel-footer">
                        {footer}
                    </div>
                )}
            </div>
        </>
    );
};

export default SlidePanel;
